import { render } from "./TruckTitle.vue?vue&type=template&id=c0b7a2ae"
import script from "./TruckTitle.vue?vue&type=script&lang=js"
export * from "./TruckTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__